export const messages_cz = {
    nameEmpty: "Název nemůže být prázdný.",
    emailEmpty: "E-mailová adresa nemůže být prázdná.",
    emailNotValid: "E-mailová adresa není platná, zadejte prosím správnou e-mailovou adresu.",
    locationEmpty: "Místo nemůže být prázdné.",
    interests: "Vyberte 3 oblasti zájmu.",
    profileSaved: "Podrobnosti profilu uloženy.",
    profilePic: "Profilový obrázek byl uložen.",
    addToFavorites:"Úspěšně přidáno do oblíbených",
    removeFromFavorites:"Úspěšně odstraněno z oblíbených"
};


// WEBPACK FOOTER //
// ./src/constants/messages_cz.js